document.addEventListener('DOMContentLoaded', () => {
  const bundleATCArray = document.querySelectorAll('.bundle-atc');
  for (var i = 0; i < bundleATCArray.length; i++) {
    const bundleATC = bundleATCArray[i];
    bundleATC.addEventListener('click', () => {
      fetch('/cart/add', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(window.bundleItems),
      })
        .then(() => {
          document.documentElement.dispatchEvent(
            new CustomEvent('product:added', {
              bubbles: true,
              detail: {
                variant: 123,
                quantity: 1,
              },
            })
          );

          document.documentElement.dispatchEvent(
            new CustomEvent('cart:refresh', {
              bubbles: true,
            })
          );
        })
        .catch((error) => {
          console.error('Error:', error);
        });
    });
  }
});
